/* eslint-disable react/prop-types */
/* eslint-disable react/no-danger */
/* eslint-disable import/order */
/* eslint-disable quote-props */
import { ConfigProvider, Flex, Tooltip, Typography } from 'antd';
import AIIcon from 'Assets/icons/icon-ai.svg';
import InfoIcon from 'Assets/icons/icon-info.svg';

import { THEME_CONFIG } from 'Constants/theme';
import styles from './Header.less';
import GenerateLoading from 'Components/AICard/GenerateLoading';

const TooltipContent = () => {
  return (
    <Flex vertical gap={8}>
      <Typography.Title level={4}>AI-powered feedback on your Clinical Notes </Typography.Title>

      <Flex vertical gap={4} className={styles.tooltipContent}>
        <Typography.Text>
          The evaluation is available for each consult and can be found in the corresponding{' '}
          <strong>Consult Summary.</strong>
        </Typography.Text>
      </Flex>
    </Flex>
  );
};

interface Props {
  title: string | JSX.Element;
  icon?: JSX.Element | null;
  isLoading?: boolean;
  openTooltip?: boolean;
}

const Header = ({ title, icon = null, isLoading, openTooltip = false }: Props) => {
  return (
    <Flex gap={8} align="center" className={styles.header} justify="space-between">
      <Flex gap={8} align="center">
        {isLoading ? <GenerateLoading /> : <img src={AIIcon} alt="AI Icon" />}
        <div>{title}</div>
        <div className={styles.beta}>
          <div className={styles.tagContent}>
            <div className={styles.text}>Beta</div>
          </div>
        </div>
        <ConfigProvider
          theme={{
            ...THEME_CONFIG,
            components: {
              Typography: {
                colorText: '#6a7882',
                fontSize: 12,
              },
              Tooltip: {
                paddingXS: 12,
                size: 320,
              },
            },
          }}>
          <Tooltip
            title={<TooltipContent />}
            color="#fff"
            placement="bottom"
            defaultOpen={openTooltip}
            classNames={{ root: styles.tooltip }}>
            <img style={{ cursor: 'pointer' }} src={InfoIcon} alt="Info Icon" />
          </Tooltip>
        </ConfigProvider>
      </Flex>
      {icon}
    </Flex>
  );
};

Header.propTypes = {};

export default Header;
